import * as React from 'react'
import g from 'glamorous'
import moment from 'moment'

import { MyLoansQueryResult, Loan } from '../../components/queries/MyLoansQuery'
import { loan as commons } from '../../components/DatagridCommons'
import { Datagrid, IDefinition } from '../../components/Datagrid'
import { moneyFormat } from '../../utils/format'
import ToPayOverlay from '../../components/ToPayOverlay'

type AdminLoansTableProps = {
  loans: MyLoansQueryResult['user']['loans']
}

const TrNoHover = g.tr(() => ({
  border: '1px solid white',
  ':hover': {
    backgroundColor: 'white !important'
  }
}))

const definition: IDefinition<Loan> = {
  columns: [
    commons.columns.date,
    commons.columns.creditor,
    commons.columns.debtors,
    commons.columns.interval,
    commons.columns.description,
    commons.columns.interest,
    commons.columns.loanedAmount,
    commons.columns.toPay,
    commons.columns.detailAction
  ],
  idGetter: data => data.id,
  defaultSort: 'date'
}

const AdminLoansTable: React.SFC<AdminLoansTableProps> = ({ loans }) => (
  <Datagrid definition={definition} data={loans}>
    {(data) => (
      <TrNoHover>
        <td colSpan={6} style={{ border: '0px' }} />
        <td style={{ border: '0px', textAlign: 'right' }}>
          Celk. jistina:{' '}
          {moneyFormat(
            data.reduce((sum, loan) => sum + (loan.state.loanedAmount || 0), 0)
          )}
        </td>
        <td style={{ border: '0px', textAlign: 'right' }}>
          <ToPayOverlay label="Celk. dluh" loans={data} date={moment()} />
        </td>
        <td style={{ border: '0px' }} />
      </TrNoHover>
    )}
  </Datagrid>
)

export default AdminLoansTable



// WEBPACK FOOTER //
// ./src/screens/dashboard/AdminLoansTable.tsx